import type Contact from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-contact/types/Contact';

/**
 * Updates the app store's `formData.contact` property with data from the component.
 */
export default async (context:any) => {
    const moduleId = context.getters.moduleId;
    const yes = context.rootGetters['appState/text'].yes;

    const data:Contact = {
        isAnonymous      : context.rootState[`${ moduleId }_anonymous`].value === yes,
        firstName        : context.rootState[`${ moduleId }_first-name`].value,
        lastName         : context.rootState[`${ moduleId }_last-name`].value,
        phone            : context.rootState[`${ moduleId }_phone`].phoneNumber,
        ext              : context.rootState[`${ moduleId }_phone`].phoneExtension,
        email            : context.rootState[`${ moduleId }_email`].value,
        address1         : context.rootState[`${ moduleId }_address`].address1,
        address2         : context.rootState[`${ moduleId }_address`].address2,
        city             : context.rootState[`${ moduleId }_address`].city,
        state            : context.rootState[`${ moduleId }_address`].state,
        zip              : context.rootState[`${ moduleId }_address`].zip,
        preferredLanguage: context.rootState[`${ moduleId }_preferred-language`].value,
        otherLanguage    : context.rootState[`${ moduleId }_other-language`].value,
    };

    await context.dispatch('updateData', {
        key  : 'contact',
        value: data,
    }, { root: true });
};